import store from '@/store'

export default [
  {
    path: '/categories',
    name: 'category',
    meta: { requiresAuth: true },
    component: () => import('@/pages/category/form.vue'),
    beforeEnter: async (to, from, next) => {
      next()
    }
  },
  {
    path: '/categories/:id',
    name: 'category-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/category/form.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('category/find', to.params.id)
      next()
    }
  }
]
